<template>
  <div class="__Login-DevBoard">
    <div class="__Login-DevBoard-ApiEnv">
      <CTitle>
        API Environment
      </CTitle>

      <CSection>
        <Row gutter="md">
          <Col>
            <RadioButton label="Dev" val="dev" v-model="apiType" color="primary" />
          </Col>
          <Col>
            <RadioButton value label="Next" val="next" v-model="apiType" color="primary" />
          </Col>
          <Col>
            <RadioButton value label="Production" val="prod" v-model="apiType" color="primary" />
          </Col>
        </Row>

        <Row gutter="md">
          <Col>
            <RadioButton
              value
              label="Localhost"
              val="localhost"
              v-model="apiType"
              color="primary"
            />
          </Col>
        </Row>
      </CSection>

      <slot />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Row from '@design-system/components/Row';
import Col from '@design-system/components/Col';
import RadioButton from '@design-system/components/RadioButton';
import Input from '@design-system/components/Input';

import CTitle from '@/components/uikit/CTitle';
import CSection from '@/components/uikit/CSection';

const messages = {
  en: {},
  ja: {},
};

export default Vue.extend({
  name: 'LoginDevBoard',
  i18n: { messages },
  components: { Row, Col, RadioButton, Input, CTitle, CSection },
  props: {
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    apiType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.__Login-DevBoard {
  border-top: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  padding-top: $space-sm;
  margin-bottom: $space-md;

  &-ApiEnv {
  }
}
</style>
